import { Controller } from "@hotwired/stimulus"

// The media monitoring prompt (owner directive 2026-09-30, BUILD-QUEUE 3c),
// rendered already open by the server (shared/_media_monitoring_prompt). Its
// four buttons are real forms answered on the server; this controller only
// covers the two ways to put it away WITHOUT answering, Escape and a click
// on the backdrop. Both hide this prompt for 24 hours: the prompt id goes
// into a per-user day cookie the server reads (StaffBase
// #media_monitoring_prompt_hidden_ids), so the next page shows the next
// prompt, if any. The same pattern as contract_reminder_controller.js, with
// its own cookie name so the two never hide each other's items. On connect
// the dialog itself takes focus (not the primary button, so Enter never
// turns monitoring on or off by accident), which also lets a screen reader
// read the question first.
export default class extends Controller {
  static targets = ["dialog"]
  static values = { promptId: Number, userId: Number }

  connect() {
    document.body.classList.add("overflow-hidden")
    if (this.hasDialogTarget) this.dialogTarget.focus()
    this.onKeydown = (e) => { if (e.key === "Escape") this.hideForToday() }
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.onKeydown)
  }

  // Only when the backdrop itself is clicked, not the panel inside it.
  backdrop(event) {
    if (event.target === this.element) this.hideForToday()
  }

  hideForToday() {
    const ids = (this.#read() || "").split(",").filter(Boolean)
    const id = String(this.promptIdValue)
    if (!ids.includes(id)) ids.push(id)
    document.cookie = `${this.#name()}=${ids.join(",")};path=/;max-age=86400;samesite=lax`
    this.element.remove()
    document.body.classList.remove("overflow-hidden")
  }

  #name() {
    return `hidden_media_monitoring_prompts_${this.userIdValue}`
  }

  #read() {
    const m = document.cookie.match(new RegExp("(?:^|; )" + this.#name() + "=([^;]*)"))
    return m ? decodeURIComponent(m[1]) : null
  }
}
